export default "__VITE_ASSET__CkXMnNo8__"